export default __webpack_public_path__ + "static/media/ruokalista.c2f392b0.png";